namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class HelperTagsAdmSpisovna extends GContentBase {
        private grid: JQuery<HTMLElement>;
        napovedaTags: DictionaryObject[];

        prepareContent() {
            this.createActions();
            this.title = "jres:33000337";
            this.grid = $("<div>").appendTo(this.element).ggrid({
                multi: true,
                data: this.napovedaTags,
                columns: new Gordic.Data.GridFormat().addTextColumn({
                    name: "key",
                    caption: "jres:33000351" //RC 33000351 : Tag
                }).addTextColumn({
                    name: "value",
                    caption: "jres:30011356"
                })
            })
            this.commandBar(this.actions.createBar(["actReturnTagsNew*", "actReturnTagsAdd*", "actClose*"]))
        }

        private createActions() {
            this.actions.addRange({
                actClose: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        this.close();
                    }
                },
                actReturnTagsAdd: {
                    caption: "jres:33000352", //RC 33000352 : Přidat vybrané formáty
                    run: (ev, ctx) => {
                        this.closeSpecial(true);
                    }
                },
                actReturnTagsNew: {
                    caption: "jres:33000353", //RC 33000353 : Vložit nové formáty
                    tooltip: "jres:33000354", //RC 33000354 : Smaže staré formáty a vloží nové
                    customClass: "g-button--primary",
                    run: (ev, ctx) => {
                        this.closeSpecial(false);
                    }
                }
            })
        }

        private closeSpecial(addTags: boolean) {
            var data = this.grid.ggrid("getSelection", false);
            var tags = "";
            data.forEach((item) => {
                tags += item.key;
            })
            this.close({ tags: tags, addTags: addTags });
        }

    }
}